import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=70e6a304&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=70e6a304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6a304",
  null
  
)

export default component.exports